import { EPublishOfferErrorCode } from '../../../redux/reducers';
import { IMappers } from '../../../repositories/monolith-python/v1/check-publish';
import { ICheckPublishFail, ICheckPublishSuccess } from '../types';
import { mapPublishInfo } from './mapPublishInfo';

export const mappers: IMappers<ICheckPublishSuccess, ICheckPublishFail> = {
  200: (response) => ({
    success: true,
    payload: mapPublishInfo(response),
  }),
  400: () => ({
    success: false,
    payload: {
      errorCode: EPublishOfferErrorCode.badRequest,
    },
  }),
};
